// eslint-disable-next-line no-restricted-imports
import GlobalStylesBase from '@mui/material/GlobalStyles';
// eslint-disable-next-line no-restricted-imports
import * as styles from '@mui/material/styles';

export type { CSSObject } from '@mui/styled-engine-sc';
export const { styled } = styles;
export const { keyframes } = styles;
export const GlobalStyles = GlobalStylesBase;

/**
 * A utility class for creating CSS class names.
 * This class is used to create a CSS class name and provides methods to retrieve the class name
 * in different formats.
 * @example
 * const myClass = new CssClass('my-class');
 * myClass.name; // 'my-class'
 * myClass.css; // '.my-class'
 * @param className - The name of the CSS class.
 */
export class CssClass {
  constructor(public className: string) {}

  /**
   * Returns the class name.
   */
  get name() {
    return this.className;
  }

  /**
   * Returns the class name prefixed with a dot.
   */
  get css() {
    return `.${this.className}`;
  }
}
